import { fetchApi } from '@/config/axiosSetting';
import { PatchVehicleInformationAfterInquiryType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchVehicleInformationAfterInquiry/patchVehicleInformationAfterInquiry.type';

export const patchVehicleInformationAfterInquiryFunction = ({
  id,
  damaged_id,
  data,
}: PatchVehicleInformationAfterInquiryType) => {
  return fetchApi.patch(
    `/property/reports/${id}/accident_users/damaged/vehicle_information/?damaged_id=${damaged_id}`,
    {
      ...data,
      id,
      damaged_id,
    },
  );
};
